import React, { useState, useEffect } from 'react';
import './AchivementsEvents.css';
import ApiService from '../../../services/apiService';

const AchivementsEvnets = () => {
  const [achievements, setAchievements] = useState([]);
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAchievements = async () => {
      try {
        const achRes = await ApiService.getAchievements();
        const achData = achRes.data.map((item) => ({
          id: item.id,
          type: item.acf?.type || 'Achievement',
          title: item.acf?.heading || item.title.rendered,
          description: item.content?.rendered || '',
          year: new Date(item.date).getFullYear(),
          link: item.acf?.upload_file?.url || item.acf?.link || '#'
        }));
        setAchievements(achData);
      } catch (err) {
        console.error('Error fetching achievements:', err);
      } finally {
        setLoading(false);
      }
    };

    const fetchEvents = async () => {
      try {
        const eventRes = await ApiService.getEvents();
        const eventData = eventRes.data.map((item) => ({
          id: item.id,
          title: item.acf?.event_title || item.title.rendered,
          date: item.acf?.event_date || item.date,
          place: item.acf?.venue || 'Rayalaseema University',
          link: item.acf?.upload_file?.url || item.acf?.link || '#'
        }));
        setEvents(eventData);
      } catch (err) {
        console.error('Error fetching events:', err);
      }
    };

    fetchAchievements();
    fetchEvents();
  }, []);

  return (
    <section className="ray-theme-vision-section">
      <div className="ray-theme-vision-container">

        <div className="ray-section-intro">
          <h2>Achivements and Events</h2>
          {/* <p className="ray-motto">
            "Empowering through Knowledge, Enlightenment through Education"
          </p> */}
        </div>

        <div className="ray-main-content-wrapper">

          {/* LEFT – ACHIEVEMENTS */}
          <div className="ray-achievements-section">
            <div className="ray-section-header">
              <h2>Faculty/Student Achievements</h2>
              <div className="ray-section-divider"></div>
            </div>

            <div className="ray-achievements-scroll-container">
              <div className="ray-achievements-scroll-content">
                {loading ? (
                  <p className="ray-loading">Loading...</p>
                ) : achievements.length > 0 ? (
                  achievements.map((a) => (
                    <div
                      key={a.id}
                      className="ray-achievement-card"
                      onClick={() => a.link !== '#' && window.open(a.link, '_blank')}
                      style={{ cursor: a.link !== '#' ? 'pointer' : 'default' }}
                    >
                      <span className="ray-achievement-type">{a.type}</span>
                      <span className="ray-achievement-year">{a.year}</span>
                      <h3 className="ray-achievement-title">{a.title}</h3>
                      {a.description && a.description.trim() && (
                        <p className="ray-achievement-description">
                          {a.description.replace(/<[^>]*>?/gm, '').slice(0, 140)}
                          {a.description.replace(/<[^>]*>?/gm, '').length > 140 ? '...' : ''}
                        </p>
                      )}
                    </div>
                  ))
                ) : (
                  <p>No achievements available</p>
                )}
              </div>
            </div>
          </div>

          {/* RIGHT – UPCOMING EVENTS */}
          <div className="ray-achievements-section">
            <div className="ray-section-header">
              <h2>Upcoming Events</h2>
              <div className="ray-section-divider"></div>
            </div>

            <div className="ray-achievements-scroll-container">
              <div className="ray-achievements-scroll-content">
                {loading ? (
                  <p className="ray-loading">Loading...</p>
                ) : events.length > 0 ? (
                  events.map((e) => (
                    <div
                      key={e.id}
                      className="ray-achievement-card event-card"
                      onClick={() => e.link !== '#' && window.open(e.link, '_blank')}
                    >
                      <span className="ray-event-date">
                        {new Date(e.date).toDateString()}
                      </span>
                      <h3 className="ray-achievement-title">{e.title}</h3>
                      <p className="ray-achievement-description">
                        Venue: {e.place}
                      </p>
                    </div>
                  ))
                ) : (
                  <p>No upcoming events</p>
                )}
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default AchivementsEvnets;
